//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//
import notificationCloseButotn from "../assets/images/notificationCloseButotn.png";
import styles from "../assets/styles/Parent.module.css";
import PlanNotification from "./PlanNotification";
import React, { useEffect, useState } from "react";
import Request from "axios";
import { BASE_URL } from "./baseURL";
import { useDispatch } from "react-redux";
import RegisterNotification from "./RegisterNotification";
import MealPlanNotification from "./MealPlanNotification";
import AssessmentNotification from "./AssessmentNotification";
import TrackerNotification from "./TrackerNotification";
import moment from "moment";
import ReminderNotification from "./ReminderNotification";
import MealApproveNotification from "./MealApproveNotification";
//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//

function NotificationPanel({ closeNav }) {
  const [notiList, setNotiList] = useState([]);
  const dispatch = useDispatch();
  const temp = JSON.parse(localStorage.getItem("user"));

  //--------------------------------------------------------------------Reminder Functions---------------------------------------------------------------------------//
  function Clientreminders(prop) {
    let tempList = [...prop];
    let remcache = JSON.parse(localStorage.getItem("reminderclient")) || [];

    // Add default reminders (for demo, can expand as needed)
    const defaultReminders = [
      {
        id: "reminder-weight",
        tableName: "reminder",
        isNotified: false,
        text: "Please update your weight for this session",
        date: moment().format("YYYY-MM-DD"),
      },
      {
        id: "reminder-photo",
        tableName: "reminder",
        isNotified: false,
        text: "Please update your Weight,Inch and Photo for this session",
        date: moment().format("YYYY-MM-DD"),
      },
      {
        id: "reminder-meal",
        tableName: "reminder",
        isNotified: false,
        text: "Please update your meal plan",
        date: moment().format("YYYY-MM-DD"),
      },
    ];

    // Only add reminders if not already in the cache
    defaultReminders.forEach((rem) => {
      if (!tempList.some((n) => n.text === rem.text)) {
        tempList.push(rem);
      }
    });

    // Merge with cache for crossed notifications
    tempList = tempList.map((n) => {
      const cached = remcache.find((c) => c.text === n.text);
      if (cached) n.isNotified = cached.isNotified;
      return n;
    });

    localStorage.setItem("reminderclient", JSON.stringify(tempList));
    return tempList;
  }

  async function adminReminders(prop) {
    let tempList = [...prop];
    let remcache = JSON.parse(localStorage.getItem("reminderadmin")) || [];

    // Example admin reminder (can add more)
    const defaultReminders = [
      {
        id: "admin-reminder-meal",
        tableName: "reminder",
        isNotified: false,
        text: "Please make sure all meal plans are updated",
        date: moment().format("YYYY-MM-DD"),
      },
    ];

    defaultReminders.forEach((rem) => {
      if (!tempList.some((n) => n.text === rem.text)) {
        tempList.push(rem);
      }
    });

    tempList = tempList.map((n) => {
      const cached = remcache.find((c) => c.text === n.text);
      if (cached) n.isNotified = cached.isNotified;
      return n;
    });

    localStorage.setItem("reminderadmin", JSON.stringify(tempList));
    return tempList;
  }

  //--------------------------------------------------------------------Fetch All Notifications---------------------------------------------------------------------------//
  const fetchAllNotifications = async () => {
    try {
      let fetchedList = [];

      if (temp?.Role === "Admin") {
        const res = await Request.get(`${BASE_URL}notifications/getAdminNotifications`);
        if (res?.data?.status === 200) {
          fetchedList = res.data.data || [];
          const reminders = await adminReminders(fetchedList);
          fetchedList = [...fetchedList, ...reminders];
        }
      } else {
        const res = await Request.post(`${BASE_URL}notifications/getClientNotifications`, {
          Client_id: temp?.id,
        });
        if (res?.data?.status === 200) {
          fetchedList = res.data.data || [];
          const reminders = Clientreminders(fetchedList);
          fetchedList = [...fetchedList, ...reminders];
        }
      }

      // Deduplicate by Notification_id or text
      const uniqueList = fetchedList.filter(
        (v, i, a) =>
          i ===
          a.findIndex(
            (t) =>
              (t.Notification_id || t.text) === (v.Notification_id || v.text)
          )
      );

      setNotiList(uniqueList);
      dispatch({ type: "NOTIFICATION_COUNT", payload: uniqueList.length });
    } catch (err) {
      console.log("Error fetching notifications!", err);
    }
  };

  //--------------------------------------------------------------------UseEffect---------------------------------------------------------------------------//
  useEffect(() => {
    fetchAllNotifications();
    const interval = setInterval(fetchAllNotifications, 60000); // refresh every minute
    return () => clearInterval(interval);
  }, [temp?.Role]);

  //--------------------------------------------------------------------Render---------------------------------------------------------------------------//
  return (
    <div id="notificationPanel" className={styles.notificationPanel}>
      <div className={styles.notificationHeading}>
        <label className={styles.notificationLabel}>Notifications</label>
        <img
          src={notificationCloseButotn}
          onClick={closeNav}
          className={styles.closebtn}
          alt=""
        />
      </div>
      {notiList?.length > 0 ? (
        notiList.map((val, i) => (
          <div key={val.id || i}>
            {val.tableName === "planhistory" && (
              <PlanNotification
                name={val.Firstname + " " + val.Lastname}
                email={val.EmailId}
                Type={val.TimeDuration}
                refresh={fetchAllNotifications}
                id={val.Notification_id}
                MobileNumber={val.Mobilenumber}
                Receipt={val.Createdby}
                Purchasedate={val.CreatedDate}
              />
            )}
            {val.tableName === "mealplan" && temp?.Role === "Admin" && (
              <MealApproveNotification
                name={val.Firstname + " " + val.Lastname}
                email={val.EmailId}
                Type={val.Type}
                refresh={fetchAllNotifications}
                id={val.Notification_id}
                MobileNumber={val.Mobilenumber}
                Receipt={"demo"}
                client={temp?.Role === "Client"}
                Purchasedate={val.CreatedDate}
                Createdby={val.Createdby}
              />
            )}
            {val.tableName === "registration" && (
              <RegisterNotification val={val} refresh={fetchAllNotifications} />
            )}
            {val.tableName === "mealplan" && (
              <MealPlanNotification
                val={val}
                refresh={fetchAllNotifications}
                client={temp?.Role === "Client"}
                date={val.Createddate}
              />
            )}
            {val.tableName === "healthassessment" && (
              <AssessmentNotification
                val={val}
                refresh={fetchAllNotifications}
                Purchasedate={val.CreatedDate}
              />
            )}
            {val.tableName === "weightracker" && (
              <TrackerNotification
                tracker={"Weight"}
                val={val}
                refresh={fetchAllNotifications}
              />
            )}
            {val.tableName === "inchlosstracker" && (
              <TrackerNotification
                tracker={"Inch"}
                val={val}
                refresh={fetchAllNotifications}
              />
            )}
            {val.tableName === "Invoice" && (
              <TrackerNotification
                tracker={"Invoice"}
                val={val}
                refresh={fetchAllNotifications}
                client={temp?.Role === "Client"}
                date={val.Createddate}
              />
            )}
            {val.tableName === "phototracker" && (
              <TrackerNotification
                tracker={"Photo"}
                val={val}
                refresh={fetchAllNotifications}
                client={temp?.Role === "Client"}
              />
            )}
            {val.tableName === "reminder" && (
              <ReminderNotification
                id={val?.id}
                notiList={notiList}
                setNotiList={setNotiList}
                isNotified={val.isNotified}
                body={val.text}
                val={val}
                refresh={fetchAllNotifications}
                clientRefresh={fetchAllNotifications}
                client={temp?.Role === "Client"}
              />
            )}
          </div>
        ))
      ) : (
        <>No notifications to show</>
      )}
    </div>
  );
}

export default NotificationPanel;
